<div class="modal-body text-center p-4">
  <span class="mfa-prompt-icon d-inline-flex align-items-center justify-content-center rounded-circle mb-3">
    <fa-icon [icon]="faShieldHalved"></fa-icon>
  </span>

  <ng-container *ngIf="!isScheduled">
    <h5 class="mb-2">Add an extra layer of security</h5>
    <p class="text-muted mb-4">
      Protect your account with two-factor authentication. It only takes a minute using an
      authenticator app, and it helps keep your compliance records safe.
    </p>
  </ng-container>

  <ng-container *ngIf="isScheduled">
    <h5 class="mb-2">Two-factor authentication is coming</h5>
    <p class="text-muted mb-4">
      From <strong>{{ requiredFrom | date:'d MMM yyyy' }}</strong>, your role will require
      two-factor authentication. Setting it up now takes a minute with an authenticator app,
      and saves you being interrupted later.
    </p>
  </ng-container>

  <div class="d-grid gap-2">
    <button type="button" class="btn btn-primary" (click)="setUpNow()">Set up now</button>
    <button type="button" class="btn btn-link text-muted" (click)="maybeLater()">
      {{ isScheduled ? 'Remind me later' : 'Maybe later' }}
    </button>
  </div>
</div>
